{
  "jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.body.heading": [
    {
      "type": 0,
      "value": "Consumption-based pricing starts with your next renewal"
    }
  ],
  "jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.body.hello": [
    {
      "type": 0,
      "value": "Hi "
    },
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": ","
    }
  ],
  "jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.body.intro": [
    {
      "type": 0,
      "value": "We’re letting you know that Assets and Virtual service agent will move to consumption-based pricing at your next renewal on "
    },
    {
      "type": 1,
      "value": "cbpEffectiveDate"
    },
    {
      "type": 0,
      "value": ". Additional charges will only apply if your usage exceeds the included limit. Check your current usage and learn more below."
    }
  ],
  "jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.body.need-to-know": [
    {
      "type": 0,
      "value": "Helpful things to know:"
    }
  ],
  "jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.comment.alt-text": [
    {
      "type": 0,
      "value": "comment"
    }
  ],
  "jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.lightbulb.alt-text": [
    {
      "type": 0,
      "value": "lightbulb"
    }
  ],
  "jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.list.optimize-schema": [
    {
      "children": [
        {
          "type": 0,
          "value": "Contact support"
        }
      ],
      "type": 8,
      "value": "a"
    },
    {
      "type": 0,
      "value": " if you have any questions"
    }
  ],
  "jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.list.usage-limit": [
    {
      "type": 0,
      "value": "Consider "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "optimizing the structure of your schemas"
        }
      ],
      "type": 8,
      "value": "a"
    }
  ],
  "jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.more-details-button": [
    {
      "type": 0,
      "value": "More details"
    }
  ],
  "jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.subject": [
    {
      "type": 0,
      "value": "[Reminder] Upcoming pricing changes to Assets and Virtual Service Agent"
    }
  ],
  "jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.support.annual.feature-usage-limits-guide": [
    {
      "type": 0,
      "value": "For more information, read more about "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "how feature usage limits work"
        }
      ],
      "type": 8,
      "value": "a"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.view-and-manage-usage-button": [
    {
      "type": 0,
      "value": "View and manage usage"
    }
  ],
  "jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.avatar.alt_text.user_avatar": [
    {
      "type": 0,
      "value": "User Avatar"
    }
  ],
  "jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.body.alt_text.connection": [
    {
      "type": 0,
      "value": "Connection"
    }
  ],
  "jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.body.alt_text.csm": [
    {
      "type": 0,
      "value": "Customer Service Management"
    }
  ],
  "jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.body.alt_text.id-badge": [
    {
      "type": 0,
      "value": "ID Badge"
    }
  ],
  "jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.body.alt_text.jsm": [
    {
      "type": 0,
      "value": "Jira Service Management"
    }
  ],
  "jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.body.alt_text.service-collection": [
    {
      "type": 0,
      "value": "Service Collection"
    }
  ],
  "jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.body.csm.description": [
    {
      "type": 0,
      "value": "Deliver better customer support and quickly turn feedback into product improvements."
    }
  ],
  "jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.body.csm.title": [
    {
      "type": 0,
      "value": "Delight external customers with purpose-built features"
    }
  ],
  "jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.body.jsm.description": [
    {
      "type": 0,
      "value": "Make internal support easier by enabling HR, IT, and other teams to resolve employee requests quickly."
    }
  ],
  "jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.body.jsm.title": [
    {
      "type": 0,
      "value": "Unite teams to deliver exceptional service experiences"
    }
  ],
  "jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.footer.alt_text.atlassian": [
    {
      "type": 0,
      "value": "Atlassian"
    }
  ],
  "jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.footer.contact_us": [
    {
      "type": 0,
      "value": "Contact us"
    }
  ],
  "jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.footer.copyright": [
    {
      "type": 0,
      "value": "Copyright "
    },
    {
      "type": 1,
      "value": "year"
    },
    {
      "type": 0,
      "value": " Atlassian Pty Ltd. All rights reserved. "
    }
  ],
  "jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.footer.location": [
    {
      "type": 0,
      "value": "We are located at 341 George Street, Sydney, NSW, 2000, Australia."
    }
  ],
  "jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.footer.privacy_policy": [
    {
      "type": 0,
      "value": "Privacy Policy"
    }
  ],
  "jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.footer.read_our_blog": [
    {
      "type": 0,
      "value": "Blog"
    }
  ],
  "jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.footer.twitter.no-translate": [
    {
      "type": 0,
      "value": "Twitter"
    }
  ],
  "jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.header.greeting": [
    {
      "type": 0,
      "value": "Hey "
    },
    {
      "type": 1,
      "value": "adminName"
    },
    {
      "type": 0,
      "value": ","
    }
  ],
  "jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.header.message": [
    {
      "type": 1,
      "value": "requestingUserName"
    },
    {
      "type": 0,
      "value": " has requested a trial of Service Collection."
    }
  ],
  "jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.request-card": [
    {
      "type": 1,
      "value": "requestingUserName"
    },
    {
      "type": 0,
      "value": " requested your organization try Service Collection, Atlassian’s solution for AI service management at high velocity."
    }
  ],
  "jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.request-card.cta": [
    {
      "type": 0,
      "value": "Try Service Collection for free"
    }
  ],
  "jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.subject": [
    {
      "type": 0,
      "value": "Hey "
    },
    {
      "type": 1,
      "value": "adminName"
    },
    {
      "type": 0,
      "value": ", "
    },
    {
      "type": 1,
      "value": "requestingUserName"
    },
    {
      "type": 0,
      "value": " wants you to start a Service Collection trial"
    }
  ],
  "post-office.jsm-issue-view-details-section.description": [
    {
      "type": 0,
      "value": "Update incidents from within Slack and summarize key events with AI."
    }
  ],
  "post-office.jsm-issue-view-details-section.dismiss-button-one": [
    {
      "type": 0,
      "value": "I don't use Slack"
    }
  ],
  "post-office.jsm-issue-view-details-section.main-heading.no-translate": [
    {
      "type": 0,
      "value": "Welcome to Placements v2"
    }
  ],
  "post-office.jsm-issue-view-details-section.reasons-modal-bullet-one": [
    {
      "type": 0,
      "value": "your usage of Jira Service Management's Alerts and Incidents features"
    }
  ],
  "post-office.jsm-issue-view-details-section.reasons-modal-explanation": [
    {
      "type": 0,
      "value": "We think Service Collection Premium will improve your team's workflow. The recommendation is based on:"
    }
  ],
  "post-office.jsm-issue-view-details-section.title": [
    {
      "type": 0,
      "value": "Resolve incidents on Slack with AI"
    }
  ]
}